import { InMemoryCache } from '@apollo/client';

/**
 * The app's Apollo cache, in its own module (like apolloDefaults.ts) so component tests can build a
 * client like the real one (this cache + APOLLO_DEFAULT_OPTIONS) without importing apollo.ts, which
 * pulls in Firebase.
 *
 * Note: the app's queries are no-cache (apolloDefaults.ts), so query results are not stored here and
 * two queries reading the same Customer never merge or clobber each other in production. In tests,
 * MockedProvider's DEFAULT cache-first store (no keyFields) would let GetCustomer and
 * GetCustomerContactHistory (YOJO-3566) overwrite the one unnormalized customer(customerId) field;
 * the CRM container tests pass this cache AND APOLLO_DEFAULT_OPTIONS so that cannot happen there either.
 */
export const createApolloCache = (): InMemoryCache =>
  new InMemoryCache({
    typePolicies: {
      Customer: {
        keyFields: ['customerId'],
      },
      Shipment: {
        keyFields: ['shipmentId'],
      },
      AcquisitionSource: {
        keyFields: ['sourceId'],
      },
      Query: {
        fields: {
          customers: {
            // Always replace the cached result instead of merging arrays
            merge(_existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  });
